// extracted by mini-css-extract-plugin
export default {"errorCode":"errorPage_errorCode__5+jm+"};